
interface Resource {
  type: 'js' | 'css';
  url: string;
}

export class ResourceLoader {
  private static loadedResources = new Set<string>();

  private static loadScript(url: string): Promise<void> {
    if (this.loadedResources.has(url)) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = url;
      script.onload = () => {
        this.loadedResources.add(url);
        resolve();
      };
      script.onerror = () => reject(new Error(`Failed to load script: ${url}`));
      document.head.appendChild(script);
    });
  }

  private static loadStyle(url: string): Promise<void> {
    if (this.loadedResources.has(url)) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      link.onload = () => {
        this.loadedResources.add(url);
        resolve();
      };
      link.onerror = () => reject(new Error(`Failed to load stylesheet: ${url}`));
      document.head.appendChild(link);
    });
  }

  public static async loadResources(resources: Resource[]): Promise<void> {
    for (const res of resources) {
      try {
        if (res.type === 'js') {
          await retryFn(async () => await this.loadScript(res.url));
        } else if (res.type === 'css') {
          await retryFn(async () => await this.loadStyle(res.url));
        }
      } catch (error) {
        console.error(error);
        throw error;
      }
    }
  }
}

// 函数执行失败 重试逻辑
async function retryFn(fn, maxRetries = 3, delay = 1000) {
  let retries = 0;
  while (retries < maxRetries) {
    try {
      await fn();
      return;
    } catch (error) {
      console.warn(`Failed to load resources on attempt ${retries + 1}. Retrying...`);
      retries++;
      if (retries >= maxRetries) throw error;
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
}

// 休眠函数
function sleep(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
